<template>
  <div>
    <div v-if="!hasChildren" class="">

        <!-- HEAD -->
        <div class="head row p-0 m-0 overflow-hidden">
            <div class="col-12 p-0 m-0 mb-5 pb-5 position-relative"  data-aos="fade-down" data-aos-easing="ease-out-cubic" data-aos-duration="500">
                <div class="container position-absolute mt-0 mt-lg-5 pt-3 pt-lg-5 px-0 px-lg-3">
                    <div class="row justify-content-end m-0 mt-0 mt-lg-5 pt-0 pt-lg-5">
                        <div class="col-12 col-lg-10 text-start text-lg-end">
                            <h1 class="text-uppercase" v-html="$t('nav.avanzando')"></h1>
                            <div class="col-10 col-lg-6 offset-0 offset-lg-6">
                                <h4>{{$t('avanzando.el-grupo')}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="scrollDownLayer d-none d-lg-block">
                    <svg class="scrollDown svg-icon">
                        <use :href="`${publicPath}icons.svg#scrollDown`"/>
                    </svg>
                </div>
                <img :src="`${publicPath}img/01avanzando.jpg`" class="img-responsive" id="imgAvanzando">
            </div>
        </div>
        <!-- end HEAD -->
        <div class="container-xxl pe-0">
            <div class="row m-0 my-5 text-white">
                <div class="col-12 col-lg-6 text-start p-0 p-lg-2 pe-0 pe-lg-5">
                    <h4 class="txtGris">{{$t('avanzando.generamos-un')}}</h4>
                    <h2 class="hoverEfect">{{$t('avanzando.triple-impacto')}}</h2>
                    <h4 class="txtGris mt-5 pe-3">{{$t('avanzando.el-proposito-corporativo')}}</h4>
                </div>
                <div class="col-12 col-lg-6 mb-5">
                    <div class="row gx-5">
                        <div class="row g-3">
                            <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-easing="easy-out" data-aos-duration="1000">
                                <div class="boxLila px-5 py-3 text-center text-lg-start fullHeight">
                                    <svg viewBox="0 0 80 75" width="80">
                                        <use :href="`${publicPath}icons.svg#personas`"/>
                                    </svg>
                                    <h3>
                                        <span style="vertical-align: bottom">{{$t('resumen.personas')}}</span>
                                    </h3>
                                    <p>{{$t('avanzando.presente-en-multiples')}}<br><br></p>

                                </div>
                            </div>
                            <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                                <div class="boxVerd px-5 py-3  text-center text-lg-start  fullHeight">
                                    <svg viewBox="0 0 80 75" width="80">
                                        <use :href="`${publicPath}icons.svg#planeta`"/>
                                    </svg>
                                    <h3>
                                        <span style="vertical-align: bottom">{{$t('resumen.planeta')}}</span>
                                    </h3>
                                    <p>{{$t('avanzando.el-compromiso-desarrollo')}}</p>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="750" data-aos-easing="easy-out" data-aos-duration="1000">
                                <div class="boxBlau px-5 py-3  text-center text-lg-start">
                                    <svg viewBox="0 0 80 75" width="80">
                                        <use :href="`${publicPath}icons.svg#prosperidad`"/>
                                    </svg>
                                    <h3>
                                        <span style="vertical-align: bottom">{{$t('home.prosperidad')}}</span>
                                    </h3>
                                    <p>{{$t('avanzando.rc-mantiene-compromiso')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-0 my-5 m-lg-0 text-white">
                <div class="col-12 col-lg-6 text-start p-0 pe-0 pe-lg-5">
                    <h4 class="txtGris">{{$t('avanzando.mediante-desarrollo')}}</h4>
                    <h2 class="hoverEfect">{{$t('avanzando.pilares')}}</h2>
                    <h4 class="txtGris mt-5 mb-5 mb-lg-3 pe-3">{{$t('avanzando.estrategia')}}</h4>
                </div>
                <div class="col-12 col-lg-6 p-0 mb-5 overflow-hidden">
                        <div class="row g-3 pe-2 pe-lg-0">
                            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-left" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                                <localized-link to="/avanzando-hacia-el-futuro/crecimiento">
                                    <div class="boxGrisHover p-0 p-lg-5 py-4">
                                        <svg viewBox="0 -5 80 80" width="80" style="margin-left: 13px">
                                            <use :href="`${publicPath}icons.svg#crecimiento`"/>
                                        </svg>
                                        <p class="mt-3">
                                            <strong style="vertical-align: bottom">{{$t('nav.crecimiento')}}</strong>
                                        </p>
                                    </div>
                                </localized-link>
                            </div>
                            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-left" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                                <localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional">
                                    <div class="boxGrisHover p-0 p-lg-5 py-4">
                                    <svg viewBox="0 -5 80 80" width="80" style="margin-left: 13px">
                                        <use :href="`${publicPath}icons.svg#excelencia`"/>
                                    </svg>
                                    <p class="mt-3">
                                        <strong style="vertical-align: bottom">{{$t('nav.excelencia-operacional')}}</strong>
                                    </p>
                                </div>
                                </localized-link>
                            </div>
                            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-left" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                                <localized-link to="/avanzando-hacia-el-futuro/innovacion">
                                    <div class="boxGrisHover p-0 p-lg-5 py-4">
                                        <svg viewBox="0 -5 80 80" width="80" style="margin-left: 13px">
                                        <use :href="`${publicPath}icons.svg#innovacion`"/>
                                    </svg>
                                    <p class="mt-3">
                                        <strong style="vertical-align: bottom">{{$t('nav.innovacion')}}</strong>
                                    </p>
                                </div>
                                </localized-link>
                            </div>
                            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-right" data-aos-delay="400" data-aos-easing="easy-out" data-aos-duration="1000">
                                <localized-link to="/avanzando-hacia-el-futuro/transformacion-digital">
                                    <div class="boxGrisHover p-0 p-lg-5 py-4">
                                        <svg viewBox="0 -5 80 80" width="80" style="margin-left: 13px">
                                        <use :href="`${publicPath}icons.svg#transformacion`"/>
                                    </svg>
                                    <p class="mt-3">
                                        <strong style="vertical-align: bottom">{{$t('nav.transformacion-digital')}}</strong>
                                    </p>
                                </div>
                                </localized-link>
                            </div>
                            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-right" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                                <localized-link to="/avanzando-hacia-el-futuro/sostenibilidad">
                                    <div class="boxGrisHover p-0 p-lg-5 py-4">
                                        <svg viewBox="-10 0 90 90" width="80" style="margin-left: 13px">
                                        <use :href="`${publicPath}icons.svg#sostenibilidad`"/>
                                    </svg>
                                    <p class="mt-3">
                                        <strong style="vertical-align: bottom">{{$t('nav.sostenibilidad')}}</strong>
                                    </p>
                                </div>
                                </localized-link>
                            </div>
                            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-right" data-aos-delay="600" data-aos-easing="easy-out" data-aos-duration="1000">
                                <localized-link to="/avanzando-hacia-el-futuro/personas">
                                    <div class="boxGrisHover p-0 p-lg-5 py-4">
                                        <svg viewBox="-5 0 80 80" width="80" style="margin-left: 13px">
                                        <use :href="`${publicPath}icons.svg#personas2`"/>
                                    </svg>
                                        <p class="mt-3">
                                            <strong style="vertical-align: bottom">{{$t('nav.personas')}}</strong>
                                        </p>
                                </div>
                                </localized-link>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="container-fluid bg-dark p-0 pt-5 p-lg-5">
            <div class="container-xxl">
                <div class="row m-0 m-lg-3 my-5 m-lg-0 text-white">
                    <div class="col-12 col-lg-6 text-start p-0 pe-0 pe-lg-5">
                        <h2 class="pb-5">{{$t('avanzando.compromiso-sostenible')}}</h2>
                    </div>
                    <div class="col-12 col-lg-6 p-0 text-start mb-5">
                        <h4>{{$t('avanzando.como-entidad')}}</h4>
                        <h5 class="mt-5">{{$t('avanzando.el-plan')}}</h5>
                        <div class="row justify-content-start m-0 p-0 mt-0 mt-lg-5 row-cols-5 row-cols-lg-6">
                            <div class="col p-0 pe-2 pe-lg-3">
                                <img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive">
                            </div>
                            <div class="col p-0 pe-2 pe-lg-3">
                                <img :src="`${publicPath}img/ods6_${locale}.gif`" class="img-responsive">
                            </div>
                            <div class="col p-0 pe-2 pe-lg-3">
                                <img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive">
                            </div>
                            <div class="col p-0 pe-2 pe-lg-3">
                                <img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive">
                            </div>
                            <div class="col p-0 pe-2 pe-lg-3">
                                <img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive">
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Footer -->
        <footer>
            <div class="row p-0 g-0">
                <div class="col-6 border-top border-dark">
                    <localized-link to="/roca-group-2022/roca-group-en-el-mundo" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                        <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                            <svg class="hoverEfect svg-icon iconFletxaLeft">
                                <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                            </svg>
                        </div>
                        <div class="col-6 col-lg-auto text-start p-0 mt-5">
                            <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                            <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.en-el-mundo") }}</h2>
                        </div>
                    </localized-link>
                </div>
                <div class="col-6 border-top border-start border-dark">
                    <localized-link to="/avanzando-hacia-el-futuro/crecimiento" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                        <div class="col-6 col-lg-auto text-end p-0 mt-5">
                            <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                            <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.crecimiento") }}</h2>
                        </div>
                        <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                            <svg class="hoverEfect svg-icon iconFletxaRight">
                                <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                            </svg>
                        </div>

                    </localized-link>
                </div>
            </div>
        </footer>
        <!-- Footer -->
    </div>
  </div>


    <router-view></router-view>
</template>

<script>
  export default {
    name: "AvanzandoHaciaElFuturoView",
      components: {
          //Presentacion
      },
      props: {
          hasChildren: Boolean
      },
      data() {
          return {
              publicPath: process.env.BASE_URL,
              locale:this.$i18n.locale,
          }
      }
  }
</script>

